// PlayProfileRole — shared type for the profile-centric model.
// Lives in /constants so any layer (components, hooks, pages) can import it
// without creating a reverse dependency (e.g. LeftSidebar -> page-scoped file).
//
// The values mirror BE shapes:
//   'player' — self-owned AthleteProfile (isManagedByGuardian=false)
//   'child'  — guardian-managed AthleteProfile (isManagedByGuardian=true), surfaced as YOUTH in UI
//   'coach'  — CoachProfile
export type PlayProfileRole = 'player' | 'coach' | 'child'

// Short uppercase label shown on header chips / role badges. Maps the internal
// 'child' value to YOUTH so the UI never surfaces the raw BE term.
export const ROLE_BADGE_LABEL: Record<PlayProfileRole, string> = {
  player: 'PLAYER',
  coach: 'COACH',
  child: 'YOUTH'
}
